import React from "react";

import { Box } from "../../layout";
import { Text } from "../../typography";

type Props = {
  htmlFor: string;
  children: React.ReactNode;
  dataTest?: string;
};

export default function FieldLabel(props: Props) {
  const { htmlFor, children, dataTest } = props;
  return (
    <Box component="label" htmlFor={htmlFor} dataTest={dataTest}>
      <Text size="xsmall" tone="neutral" weight="bold">
        {children}
      </Text>
    </Box>
  );
}
